import type { ActionContext } from 'vuex';

import api from '@/tools/api';

import type { ProductionQueueItem, ProductionQueueMeta, ProductionState } from './types';

export function parseQueueResponse(response: any): {
  data: ProductionQueueItem[];
  meta: ProductionQueueMeta | null;
} {
  let data = [];
  let meta = null;

  if (Array.isArray(response)) {
    data = response;
  } else if (response && typeof response === 'object') {
    data = response.data || [];
    meta = response.meta || null;
  }

  return { data, meta };
}

export async function fetchQueue(
  { commit, state }: ActionContext<ProductionState, any>,
  filters?: Record<string, any> & { page?: number },
) {
  commit('setLoading', true);
  commit('setError', null);

  try {
    const { page: requestedPage, ...filterParams }: Record<string, any> & { page?: number } =
      filters || state.activeFilters;
    const page = requestedPage ?? state.queue.meta?.current_page ?? 1;
    const params: Record<string, any> = { ...filterParams, page };
    delete params.per_page;

    // Transform placementDate to placement_date for backend.
    if (params.placementDate) {
      params.placement_date = params.placementDate;
      delete params.placementDate;
    }

    let { data, meta } = parseQueueResponse(await api.get('/production/queue', { params }));

    if (data.length === 0 && meta && meta.current_page > meta.last_page) {
      ({ data, meta } = parseQueueResponse(
        await api.get('/production/queue', { params: { ...params, page: meta.last_page } }),
      ));
    }

    commit('setQueue', { data, meta });
  } catch (error: any) {
    console.error('fetchQueue error:', error);
    commit('setError', error.message || 'Failed to fetch queue');
    commit('setQueue', { data: [], meta: null });
  } finally {
    commit('setLoading', false);
  }
}
